import { render, staticRenderFns } from "./ChangeProductOrderFormDialog.vue?vue&type=template&id=37564353"
import script from "./ChangeProductOrderFormDialog.vue?vue&type=script&lang=js"
export * from "./ChangeProductOrderFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports